import React, { useState, useEffect, useRef } from 'react';
import { GrPowerCycle } from 'react-icons/gr';
import { IoIosTimer } from 'react-icons/io';
import { FaCoins } from 'react-icons/fa';
import SalesChart from './SalesChart';
import DataTable from '../common/DataTable';
import { format } from 'date-fns';
import { getSaleStatsByStatus, getSaleStatsByVendor } from '../service/dashBoardService';
import subDays from 'date-fns/subDays';
import VendorPieChart from './VendorPieChart';

export default function DashBoard() {
   const [startDate, setStartDate] = useState(subDays(new Date(), 0));
   const [endDate, setEndDate] = useState(new Date());
   // const [currentData, setCurrentData] = useState([]);
   const [groupBySales, setGroupBySales] = useState([]);
   const [groupByVendors, setGroupByVendors] = useState([]);
   const [totalSalesAmount, setTotalSalesAmount] = useState([]);
   const [totalSalesCount, setTotalSalesCount] = useState([]);
   const [totalPendings, setTotalPendings] = useState({});
   const targetRef = useRef();
   const [dimensions, setDimensions] = useState({ width: 0, height: 291 });
   let pageSize = 15;

   const fetchSaleStatsByStatus = () => {
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      getSaleStatsByStatus(formatedStartDate, formatedEndDate).then((result) => {
         let saleStats = result.data.data;
         const totalAmount = saleStats.reduce((sum, item) => {
            sum = sum + item.totalSalesAmount;
            return sum;
         }, 0);

         const totalCount = saleStats.reduce((sum, item) => {
            sum = sum + item.numberSales;
            return sum;
         }, 0);
         const totalPendingObject = saleStats.reduce(
            (sum, item) => {
               if (item.saleStatusName === 'PAYMENT PENDING') {
                  sum['count'] += item.numberSales;
                  sum['totalAmount'] += item.totalSalesAmount;
               }
               return sum;
            },
            { count: 0, totalAmount: 0 }
         );
         setTotalPendings(totalPendingObject);
         setTotalSalesAmount(totalAmount);
         setTotalSalesCount(totalCount);
         // setCurrentData(saleStats);
         setGroupBySales(saleStats);
      });
   };

   const fetchSaleStatsByVendor = () => {
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      getSaleStatsByVendor(formatedStartDate, formatedEndDate).then((result) => {
         let saleStatsVendor = result.data.data;
         setGroupByVendors(saleStatsVendor);
      });
   };

   const formatNumber = (input) => {
      return new Intl.NumberFormat('en-US', {}).format(input);
   };
   const columnsStatus = [
      {
         columnCaption: 'Status',
         columnKey: 'key',
         content: (item) => <span style={{ color: '#38a8ed' }}>{item.saleStatusName}</span>,
      },
      {
         columnCaption: 'Count',
         columnKey: 'numberSales',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'totalSalesAmount',
         content: (item) => <span style={{ color: '#38a8ed' }}>{formatNumber(item.totalSalesAmount)}</span>,
      },
      {
         columnCaption: 'Average',
         columnKey: 'averageSalesAmount',
         content: (item) => <span style={{ color: '#38a8ed' }}>{formatNumber(item.averageSalesAmount)}</span>,
      },
   ];

   const columnsVendors = [
      {
         columnCaption: 'VendorName',
         columnKey: 'key',
         content: (item) => <span style={{ color: '#c28005' }}>{item.vendorName}</span>,
      },
      {
         columnCaption: 'Count',
         columnKey: 'numberSales',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'totalSalesAmount',
         content: (item) => <span style={{ color: '#38a8ed' }}>{formatNumber(item.totalSalesAmount)}</span>,
      },
      {
         columnCaption: 'Average',
         columnKey: 'averageSalesAmount',
         content: (item) => <span style={{ color: '#d63912' }}>{Math.ceil(item.averageSalesAmount)}</span>,
      },
   ];

   const handleResize = () => {
      if (targetRef.current)
         setDimensions({
            width: targetRef.current.offsetWidth,
            height: targetRef.current.offsetHeight,
         });
   };

   useEffect(() => {
      if (targetRef.current)
         setDimensions({
            width: targetRef.current.offsetWidth,
            height: targetRef.current.offsetHeight,
         });
      window.addEventListener('resize', handleResize);
      // clean up the event
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, []);

   useEffect(fetchSaleStatsByStatus, []);
   useEffect(fetchSaleStatsByVendor, []);

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-4 col-lg-4'>
               <div className='card card-dashboard-sale mb-2'>
                  <div className='card-body'>
                     <h6 className='font-weight-light'>
                        <span className='mr-2 icon-custom-color'>
                           <FaCoins />
                        </span>
                        <span className='text-muted'>
                           {' | '} {formatNumber(totalSalesAmount)} {'RWF'}
                        </span>
                     </h6>
                     <hr />
                     <h5>
                        <span className='text-muted'>Total Sales : {totalSalesCount}</span>
                     </h5>
                  </div>
               </div>
            </div>
            <div className='col-md-4 col-lg-4'>
               <div className='card card-dashboard-pending mb-2'>
                  <div className='card-body'>
                     <h6 className='font-weight-light'>
                        <span className='mr-2 icon-custom-color'>
                           <GrPowerCycle />
                        </span>
                        <span className='text-muted'>
                           {formatNumber(totalPendings.totalAmount)} {'RWF'}
                        </span>
                     </h6>
                     <hr />
                     <h5>
                        <span className='text-muted'>Payment Pending : {totalPendings.count}</span>
                     </h5>
                  </div>
               </div>
            </div>
            <div className='col-md-4 col-lg-4'>
               <div className='card card-dashboard-processing mb-2'>
                  <div className='card-body'>
                     <h6 className='font-weight-light'>
                        <span className='mr-2 icon-custom-color'>
                           <IoIosTimer />
                        </span>
                        <span className='text-muted'>0.4 Sec</span>
                     </h6>
                     <hr />
                     <h5>
                        <span className='text-muted'>Avg. Processing Time</span>
                     </h5>
                  </div>
               </div>
            </div>
         </div>
         <div className='mt-3 row'>
            <div className='col-md-6 col-lg-6'>
               <div className='card'>
                  <div className='card-body'>
                     <SalesChart items={groupBySales} />
                  </div>
               </div>
            </div>
            <div className='col-md-6 col-lg-6' ref={targetRef}>
               <div className='card'>
                  <div className='card-body'>
                     <VendorPieChart items={groupByVendors} height={dimensions.height > 291 ? 250 : dimensions.height} width={dimensions.width} />
                  </div>
               </div>
            </div>
         </div>
         <div className='mt-3 row'>
            <div className='mt-2 col-md-6 col-lg-6'>
               <div className='card'>
                  <div className='card-body'>
                     <div className='card-title'>Sales By Status</div>
                     <div className='table-responsive'>
                        <DataTable items={groupBySales} pageSize={pageSize} rowKey={'transactionId'} columns={columnsStatus}></DataTable>
                     </div>
                  </div>
               </div>
            </div>
            <div className='mt-2 col-md-6 col-lg-6'>
               <div className='card'>
                  <div className='card-body'>
                     <div className='card-title'>Sales By Vendor</div>
                     <div className='table-responsive'>
                        <DataTable items={groupByVendors} pageSize={pageSize} columns={columnsVendors}></DataTable>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
